// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";

// GA4 pageview tracking (fires on each route change)
import usePageTracking from "./components/usePageTracking";

// Layout + utilities
import PageLayout from "./components/PageLayout";
import ScrollManager from "./components/ScrollManager";

// Pages
import TarotApp from "./TarotApp";
import About from "./pages/About";
import Disclaimer from "./pages/Disclaimer";
import Privacy from "./pages/Privacy";
import EmotionPage from "./pages/EmotionPage";
import WhatsTarot from "./pages/WhatsTarot";
import MajorArcana from "./pages/MajorArcana";
import Wands from "./pages/Wands";
import Cups from "./pages/Cups";
import Swords from "./pages/Swords";
import Pentacles from "./pages/Pentacles";
import TarotCards from "./pages/TarotCards";
import TarotCardPage from "./pages/TarotCardPage";
import SearchResults from "./pages/SearchResults";
import FateFriday from "./pages/FateFriday";
import FullMoon from "./pages/FullMoon";
import YesNoTarot from "./pages/YesNoTarot";
import Readmycard from "./pages/Readmycard";
import Tarotscope from "./pages/Tarotscope";
import TarotscopeSign from "./pages/TarotscopeSign"; // ✅ added

export default function App() {
  // ensures GA4 sees SPA navigation
  usePageTracking();

  return (
    <PageLayout>
      {/* ensures new pages open at the top; honors #hash anchors */}
      <ScrollManager />

      <Routes>
        {/* STATIC SITE PAGES */}
        <Route path="/about" element={<About />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/what-is-tarot-cards-complete-guide" element={<WhatsTarot />} />
        <Route path="/fate-friday" element={<FateFriday />} />
        <Route path="/full-moon" element={<FullMoon />} />
        <Route path="/tarotscope" element={<Tarotscope />} />
        <Route path="/tarotscope/:slug" element={<TarotscopeSign />} /> {/* ✅ added */}
        <Route path="/readmycard" element={<Readmycard />} />

        {/* EMOTION PAGES */}
        <Route path="/tarot-for-:emotionSlug/" element={<EmotionPage />} />
        <Route path="/emotions/:emotionSlug" element={<EmotionPage />} />

        {/* CARDS */}
        <Route path="/tarot-cards" element={<TarotCards />} />
        <Route path="/tarot-card/:cardSlug" element={<TarotCardPage />} />
        <Route path="/tarot/major-arcana-tarot-suit-cards-meaning" element={<MajorArcana />} />
        <Route path="/tarot/wands-tarot-suit-cards-meaning" element={<Wands />} />
        <Route path="/tarot/cups-tarot-suit-cards-meaning" element={<Cups />} />
        <Route path="/tarot/swords-tarot-suit-cards-meaning" element={<Swords />} />
        <Route path="/tarot/pentacles-tarot-suit-cards-meaning" element={<Pentacles />} />

        {/* YES/NO TAROT */}
        <Route path="/yes-no-tarot" element={<YesNoTarot />} />

        {/* HOME + SEARCH */}
        <Route path="/" element={<TarotApp />} />
        <Route path="/search" element={<SearchResults />} />

        {/* Optional 404
        <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </PageLayout>
  );
}
